import { render, staticRenderFns } from "./JoinedBrandNotice.vue?vue&type=template&id=0e634ad7"
import script from "./JoinedBrandNotice.vue?vue&type=script&lang=js"
export * from "./JoinedBrandNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports